export default function BreadcrumbSibling({ child, onClick }) {
  return (
    <div className="btn clickable" key={child.key} onClick={onClick.bind(this, child)}>{child.key}</div>
  );
}
